import {
  Observable
} from 'rxjs';
import {
  ProgramSearchResultModel,
  UserModel
} from '../../models';

export abstract class BaseProgramDirectorService {

  public abstract getProgramsWithRevisions(programs: any): Observable<any>;
  public abstract addMaintainerToProgram(programId: string, programPassword: string): Observable<boolean>;

  public abstract getProgramsForUser(user: UserModel, includeFields: string[]): Observable<ProgramSearchResultModel[]>;

  public abstract removeProgram(program: ProgramSearchResultModel): Observable<boolean>;

}
